import { DEFAULT_VIEW_PATH } from "src/app/ui/DefaultViewPath";

export const DASHBOARD_VIEW_PATH = DEFAULT_VIEW_PATH;